const data = [
  {
    id: 1,
    year: "2022",
    category: "WEB APPLICATION",
    title: "Cobijado Ecommerce",
    image: "cobijado.jpg",
    technologies: [
      "React",
      "React-bootstrap",
      "SwiperJs",
      "HTML",
      "CSS",
      "JS",
      "Firebase",
    ],
    desc: `an Ecommerce is a digital e-commerce platform that allows users to make purchases and sales online. In this case, the Ecommerce is focused on fashion products for women, men and children.
    
    To develop this platform, we used React technology, which is a JavaScript library that allows creating interactive and reusable user interfaces. We also used Bootstrap, which is a CSS framework that facilitates the creation of responsive and stylish designs. 

    We used Firebase, a Google platform that provides real-time database hosting, user authentication and file storage services, among others, was used.
    `,
    links: {
      code: "https://github.com/Tono2007/CarsLandingPage",
      page: "https://tono2007.github.io/CarsLandingPage/",
    },
  },
  {
    id: 2,
    year: "2022",
    category: "WEB APPLICATION",
    title: "GASUT Marketplace",
    image: "gasutjpg.jpg",
    technologies: [
      "ReactJs",
      "bootstrap",
      "HTML",
      "CSS",
      "react-router-dom",
      "Firebase auth",
    ],
    desc: `This application is a digital platform that is designed so that neighbors in a community can interact with each other and share products, items and services. The application has a friendly and easy to use interface, so that users can navigate and perform the actions they want in a simple way.

    In the application, users can post products or items that they no longer need and wish to give to their neighbors. They can also offer services they are willing to provide, such as appliance repairs, yoga classes, home cleaning, among others.
    `,
    links: {
      code: "https://github.com/Tono2007/Movies-App",
      page: "https://movies-app-tono2007.vercel.app",
    },
  },
  {
    id: 3,
    year: "2022",
    category: "WEB APPLICATION",
    title: "Chat-App",
    image: "chatreal.png",
    technologies: [
      "React",
      "Material UI",
      "HTML",
      "CSS",
      "JS",
      "Crypto.js",
      "Moment",
      "React-router-dom",
      "Firebase",
    ],
    desc: `This application is a digital platform that allows users to communicate with each other instantly and in real time through text messages, audios and videos. In addition, the application allows the creation of chat groups so that several friends can chat at the same time.

    To develop this application, the React library was used for the client-side logic, HTML and CSS for the user interface and Firebase as a database hosting and user authentication platform.`,
    links: {
      code: "https://github.com/jonathan20dev/My-chapp-Message-Application",
      page: "https://pokedex-tono2007.vercel.app/",
    },
  },
  {
    id: 8,
    year: "2022",
    category: "WEB APPLICATION",
    title: "PoepleChic - Ecommerce for women",
    image: "chic.png",
    technologies: [
      "React",
      "Redux",
      "bootstrap",
      "HTML",
      "CSS",
      "JS",
      "Emailjs-com",
      "Framer-motion",
      "React-router-dom",
      "React-toastify",
      "Remixicon",
      "Firebase",
      "cypress",
    ],
    desc: `Digital platform that is designed for users to buy textiles and women's products online. The application has a user-friendly and easy-to-use interface so that users can easily navigate and make the purchases they want.

    In the application, users can search for products by categories or keywords and add them to the shopping cart for checkout.
    
    In addition, the application has an administrator panel to modify, add or delete products. Also, to see the orders that have been placed and promotions can be added.`,
    links: {
      code: "https://github.com/jonathan20dev/PeopleChic",
      page: "https://tono2007.github.io/CarsLandingPage/",
    },
  },
  {
    id: 7,
    year: "2022",
    category: "WEB APPLICATION",
    title: "Web Clasifier Using Bayes",
    image: "5bayes.png",
    technologies: [
      "ReactJs",
      "HTML",
      "CSS",
      "Material-ui (MUI)",
      "JS",
      "PieChart",
      "Puppeteer",
      "Nodejs",
    ],
    desc: `The Bayes algorithm is a classification method based on probability and statistics. In this case, it is used to classify web pages into different categories according to their content.
    
    To build the application, different technologies are used. React is a JavaScript framework that is used to build the user interface of the application. Chartjs is a JavaScript library that is used to create charts and visualizations to display the results of ranking web pages.

    Node.js is a JavaScript platform that is used to build the backend of the application. In this case, it is used to handle the ranking of web pages using Bayes algorithm.    `,
    links: {
      code: "https://github.com/jonathan20dev/Web_Clasifier-Using-Bayes",
      page: "https://movies-app-tono2007.vercel.app",
    },
  },
  {
    id: 6,
    year: "2022",
    category: "WEB APPLICATION",
    title: "To-Do",
    image: "todo.png",
    technologies: ["ReactJs", "HTML", "CSS", "JS", "LocalStorage"],
    desc: `This application is a digital platform used to organize and manage daily tasks. It was developed using React

    In the app, users can add tasks to a list, mark tasks as completed and delete them when they are no longer needed. The application has a simple and intuitive interface so that users can manage their tasks easily and quickly.`,
    links: {
      code: "https://github.com/jonathan20dev/TodoList",
      page: "https://pokedex-tono2007.vercel.app/",
    },
  },
];

export default data;
